import {TrackersAction, TrackersActionType} from './trackers.action';
import {initialTrackersState, TrackersState} from './trackers.state';

export function trackersReducer(state: TrackersState = initialTrackersState, action: TrackersAction): TrackersState {
  switch (action.type) {
    case TrackersActionType.GET_ALL_SUCCESS:
      return {...state, trackerData: action.payload.trackerData};
    case TrackersActionType.GET_SINGLE_SUCCESS:
      return {
        ...state,
        tracker: action.payload.trackerDetailData?.tracker,
        trackerDetailData: action.payload.trackerDetailData,
      };

    case TrackersActionType.CREATE_NEW_SUCCESS:
    case TrackersActionType.UPDATE_SUCCESS:
    case TrackersActionType.UPDATE_METRIC_VALUE_SUCCESS:
    case TrackersActionType.ADD_METRIC_TO_TRACKER_SUCCESS:
    case TrackersActionType.UPDATE_METRIC_SUCCESS: {
      const updatedTracker = action.payload.tracker;
      const updatedTrackerData = state.trackerData
        ? {
            ...state.trackerData,
            trackers: state.trackerData.trackers?.map(t => (t._id === updatedTracker._id ? updatedTracker : t)),
          }
        : null;
      return {
        ...state,
        tracker: updatedTracker,
        trackerData: updatedTrackerData,
      };
    }
    case TrackersActionType.UPDATE_TEMP_TRACKER_PROJECT_ID:
      return {...state, tempTrackerProjectId: action.payload.projectId};
    case TrackersActionType.CLEAR:
      return {
        trackerData: null,
        tracker: null,
        trackerDetailData: null,
        tempTrackerProjectId: null,
      };
    default:
      return state;
  }
}
